import React from 'react'

// Components
import StoreLocatorContent from '../../components/store-locator/index'

/* Providers */
import { StoreLocatorProvider } from '../../contexts/store-locator-context'
import { APIProvider } from '@vis.gl/react-google-maps';

/* Configs */
import { getConfig } from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../../utils/site-config'

const StoreLocator = () => {
    /* Configs */
    const config = getConfig()
    const {site} = useMultiSite()
    const siteId = site?.id
    const GOOGLE_MAPS_API_KEY = getSiteEnvVarValue(config.app, 'GOOGLE_MAPS_API_KEY', siteId) || null

    return (
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
            <StoreLocatorProvider>
                <StoreLocatorContent />
            </StoreLocatorProvider>
        </APIProvider>
    )
}

StoreLocator.getTemplateName = () => 'store-locator'

export default StoreLocator
